var waitFor = require('../utils/waitFor');

waitFor('#pcns-table', function() {

  var dt = require( 'datatables.net' )( window, jQuery ),
    dtUtils = require('../utils/dtUtils');


  // Results table
  var colData = [
    {
      title: 'PCN',
      className: 'col-emphasize',
      func: function (data) {
        return '<a href="' + data.url + '">' + data.number + '</a>';
      },
      width: '100px'
    },
    {
      prop: 'title',
      title: 'Title',
      className: 'col-alignleft'
    },
    {
      func: function (data) {
        return '<span style="display:none">' + data.release_date_sort + '</span>' + data.release_date + '</a>';
      },
      title: 'Date of Notification'
    }
  ];

  var dtOpts = {
    data: dtUtils.formatResultsData(window.pcnsData, colData),
    columns: dtUtils.buildDataTablesColumns(colData),
    searching: true,
    lengthChange: false,
    info: false,
    autoWidth: false,
    paging: false,
    order: [
      [2, 'desc']
    ],
    language: {
      search: "Search PCNs:"
    }
  };

  if(window.pcnsData.length > 20) {
    dtOpts.dom = 'f<"dataTables-top-pagination"p>t<"dataTables-bottom-pagination"p>';
    dtOpts.pageLength = 20;
    dtOpts.paging = true;
  }

  var dtInstance = $('#pcns-table').DataTable(dtOpts);

  $('#pcns-table').on('page.dt', function(){
    $('html, body').animate({
        scrollTop: $("#pcns-table").offset().top - 40
    }, 300);
  });



});
